import BFFAPI from './utils/BFFAPI';

class AccessGroupsAssetsAPI extends BFFAPI {
  patchAccessGroupsAssets = (
    accessGroupId: string,
    assetsToBeAdded: string[],
    assetsToBeDeleted: string[]
  ) => {
    const req = this.fetchHelper.createPatchRequest(
      `${process.env.ENDPOINT_BFF}/access-groups/${accessGroupId}/assets`,
      {
        assetsToBeAdded: assetsToBeAdded,
        assetsToBeDeleted: assetsToBeDeleted,
      }
    );
    return this.fetch(req);
  };
}

export default new AccessGroupsAssetsAPI('');
